var version = {
    "name":      "dativery",
    "buildDateCode": "20260302-161906",
    "buildDate": "Mon Mar 02 2026 16:19:06 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260302-161906",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;